module.exports = __webpack_public_path__ + "static/about-us-our-audience-photo-bd4f1ec7b60e5025647519473d5a4b68.jpg";